import React, { useState, useEffect, useRef } from 'react'
import { CKEditor as CKEditor5 } from '@ckeditor/ckeditor5-react'
import './ckeditor.css'
import { LineHeight } from '@rickx/ckeditor5-line-height'
import { ClassicEditor } from 'ckeditor5'
import uploader from './ckeditor-uploader'
import {
    Plugin,
    ButtonView,
    AccessibilityHelp,
    Alignment,
    Autoformat,
    AutoImage,
    AutoLink,
    Autosave,
    BalloonToolbar,
    Bold,
    CKBox,
    CKBoxImageEdit,
    CloudServices,
    Code,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    Heading,
    HorizontalLine,
    ImageBlock,
    ImageCaption,
    ImageInline,
    ImageInsert,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageTextAlternative,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    Mention,
    PageBreak,
    Paragraph,
    PasteFromOffice,
    PictureEditing,
    RemoveFormat,
    SelectAll,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    Strikethrough,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextTransformation,
    TodoList,
    Underline,
    Undo,
} from 'ckeditor5'
import { ExportPdf, ExportWord, ImportWord } from 'ckeditor5-premium-features'
import 'ckeditor5/ckeditor5.css'
import 'ckeditor5-premium-features/ckeditor5-premium-features.css'

/**
 * Please update the following values with your actual tokens.
 * Instructions on how to obtain them: https://ckeditor.com/docs/trial/latest/guides/real-time/quick-start.html
 */

export default function CkeditorNew(props) {
    const formik = props.formik
    const data = props.data

    console.log(formik, 'gggggg', data)
    const editorContainerRef = useRef(null)
    const editorMenuBarRef = useRef(null)
    const editorToolbarRef = useRef(null)
    const editorOutlineRef = useRef(null)
    const editorRef = useRef(null)
    const [isLayoutReady, setIsLayoutReady] = useState(false)

    useEffect(() => {
        setIsLayoutReady(true)

        return () => setIsLayoutReady(false)
    }, [])

    console.log(isLayoutReady, 'jjjjjjjjjjj')

    const editorConfig = {
        dataFilter: {
            disallowedElements: ['script'],
            disallowedAttributes: {
                '*': ['on*', 'style'],
            },
        },
        clipboard: {
            keepInheritedStyles: true,
        },
        language: data.language || 'en',
        ui: {
            direction: data.dir || 'ltr',
        },
        htmlSupport: {
            allow: [
                {
                    name: /.*/,
                    attributes: true,
                    classes: true,
                    styles: true,
                },
                {
                    name: 'p',
                    attributes: ['dir'],
                    classes: true,
                    styles: true,
                },
                {
                    name: 'br',
                    attributes: false,
                },
            ],
        },
        toolbar: {
            items: [
                'undo',
                'redo',
                '|',
                'previousPage',
                '|',
                'insertMergeField',
                'previewMergeFields',
                '|',
                'formatPainter',
                '|',
                'heading',
                '|',
                'fontSize',
                'fontFamily',
                'fontColor',
                'fontBackgroundColor',
                '|',
                'bold',
                'italic',
                'underline',
                '|',
                'link',
                'insertImage',
                'insertTable',
                'lineHeight',
                '|',
                'alignment',
                '|',
                'bulletedList',
                'numberedList',
                'multiLevelList',
                'todoList',
                'outdent',
                'indent',
            ],
            shouldNotGroupWhenFull: false,
        },
        lineHeight: {
            options: ['default', '10px', 2, '150%', '8em'],
        },
        extraPlugins: [
            AccessibilityHelp,
            Alignment,
            Autoformat,
            AutoImage,
            AutoLink,
            Autosave,
            BalloonToolbar,
            Bold,
            CKBox,
            CKBoxImageEdit,
            CloudServices,
            Code,
            Essentials,
            ExportPdf,
            ExportWord,
            FindAndReplace,
            FontBackgroundColor,
            FontColor,
            FontFamily,
            FontSize,
            Heading,
            HorizontalLine,
            ImageBlock,
            ImageCaption,
            ImageInline,
            ImageInsert,
            ImageInsertViaUrl,
            ImageResize,
            ImageStyle,
            ImageTextAlternative,
            ImageToolbar,
            ImageUpload,
            ImportWord,
            Indent,

            IndentBlock,
            Italic,
            Link,
            LinkImage,
            List,
            ListProperties,
            LineHeight,
            Mention,
            PageBreak,
            Paragraph,
            PasteFromOffice,
            PictureEditing,
            RemoveFormat,
            SelectAll,
            SpecialCharacters,
            SpecialCharactersArrows,
            SpecialCharactersCurrency,
            SpecialCharactersEssentials,
            SpecialCharactersLatin,
            SpecialCharactersMathematical,
            SpecialCharactersText,
            Strikethrough,
            Subscript,
            Superscript,
            Table,
            TableCaption,
            TableCellProperties,
            TableColumnResize,
            TableProperties,
            TableToolbar,
            TextTransformation,
            TodoList,
            Underline,
            Undo,
        ],
        // extraPlugins: [DocumentOutlineToggler],
        balloonToolbar: [
            'lineHeight',
            'bold',
            'italic',
            '|',
            'link',
            'insertImage',
            '|',
            'bulletedList',
            'numberedList',
        ],
        exportPdf: {
            stylesheets: [
                /* This path should point to application stylesheets. */
                /* See: https://ckeditor.com/docs/ckeditor5/latest/features/converters/export-pdf.html */
                './ckeditor.css',
                /* Export PDF needs access to stylesheets that style the content. */
                'https://cdn.ckeditor.com/ckeditor5/43.1.0/ckeditor5.css',
                'https://cdn.ckeditor.com/ckeditor5-premium-features/43.1.0/ckeditor5-premium-features.css',
            ],
            fileName: 'export-pdf-demo.pdf',
            converterOptions: {
                format: 'A4',
                margin_top: '20mm',
                margin_bottom: '20mm',
                margin_right: '12mm',
                margin_left: '12mm',
                page_orientation: 'portrait',
            },
        },
        fontFamily: {
            options: [
                'default',
                'Helvetica',
                'Arial',
                'Georgia, serif',
                'Courier New, Courier, monospace',
                'Tahoma, Geneva, sans-serif',
                'Times New Roman, Times, serif',
                'Verdana, Geneva, sans-serif',
            ],
            default: 'Arial',
        },
        fontSize: {
            options: [
                'default',
                '10px',
                '12px',
                '14px',
                '16px',
                '18px',
                '20px',
            ],
            default: '14px',
        },

        heading: {
            options: [
                {
                    model: 'paragraph',
                    title: 'Paragraph',
                    class: 'ck-heading_paragraph',
                },
                {
                    model: 'heading1',
                    view: 'h1',
                    title: 'Heading 1',
                    class: 'ck-heading_heading1',
                },
                {
                    model: 'heading2',
                    view: 'h2',
                    title: 'Heading 2',
                    class: 'ck-heading_heading2',
                },
                {
                    model: 'heading3',
                    view: 'h3',
                    title: 'Heading 3',
                    class: 'ck-heading_heading3',
                },
                {
                    model: 'heading4',
                    view: 'h4',
                    title: 'Heading 4',
                    class: 'ck-heading_heading4',
                },
                {
                    model: 'heading5',
                    view: 'h5',
                    title: 'Heading 5',
                    class: 'ck-heading_heading5',
                },
                {
                    model: 'heading6',
                    view: 'h6',
                    title: 'Heading 6',
                    class: 'ck-heading_heading6',
                },
            ],
        },
        image: {
            toolbar: [
                'toggleImageCaption',
                'imageTextAlternative',
                '|',
                'imageStyle:inline',
                'imageStyle:wrapText',
                'imageStyle:breakText',
                '|',
                'resizeImage',
                '|',
                'ckboxImageEdit',
            ],
        },
        initialData: '',
        // licenseKey: LICENSE_KEY,
        link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://',
            decorators: {
                toggleDownloadable: {
                    mode: 'manual',
                    label: 'Downloadable',
                    attributes: {
                        download: 'file',
                    },
                },
            },
        },
        list: {
            properties: {
                styles: true,
                startIndex: true,
                reversed: true,
            },
        },
        mention: {
            feeds: [
                {
                    marker: '@',
                    feed: [
                        /* See: https://ckeditor.com/docs/ckeditor5/latest/features/mentions.html */
                    ],
                },
            ],
        },
        menuBar: {
            isVisible: true,
        },
        mergeFields: {
            /* Read more: https://ckeditor.com/docs/ckeditor5/latest/features/merge-fields.html#configuration */
        },
        pagination: {
            pageWidth: '21cm',
            pageHeight: '29.7cm',
            pageMargins: {
                top: '20mm',
                bottom: '20mm',
                right: '12mm',
                left: '12mm',
            },
        },
        paste: {
            removeStyles: true,
        },
        table: {
            contentToolbar: [
                'tableColumn',
                'tableRow',
                'mergeTableCells',
                'tableProperties',
                'tableCellProperties',
            ],
        },
    }

    return (
        <>
            {isLayoutReady && (
                <>
                    <CKEditor5
                        editor={ClassicEditor}
                        config={editorConfig}
                        onReady={(editor) => {
                            if (editor)
                                editor.plugins.get(
                                    'FileRepository'
                                ).createUploadAdapter = (loader) =>
                                    new uploader(loader)
                            return editor
                        }}
                        data={formik.values[data.name]}
                        onChange={(event, editor) => {
                            if (!props.dynamic_ckeditor_size) {
                                editor.execute('fontFamily', {
                                    value: 'Arial',
                                })
                                editor.execute('fontSize', {
                                    value: '14px',
                                })
                            }

                            formik.setFieldValue(
                                data.name,
                                editor.getData() || ' '
                            )
                        }}
                    />
                </>
            )}
        </>
    )
}
